import { render, staticRenderFns } from "./Memorize.vue?vue&type=template&id=2058e511&scoped=true&"
import script from "./Memorize.vue?vue&type=script&lang=js&"
export * from "./Memorize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2058e511",
  null
  
)

export default component.exports